import { GetExpenseResponse } from '@orbit/api-types'
import api from '@lib/api'
import { queryKeys } from '@lib/queryKeys'
import { useMutation, useQueryClient } from '@tanstack/react-query'

export const useUploadExpensePicture = () => {
    const queryClient = useQueryClient()

    return useMutation<
        GetExpenseResponse,
        Error,
        { tripId: string; expenseId: number; file: File }
    >({
        mutationFn: async ({ tripId, expenseId, file }) => {
            const formData = new FormData()
            formData.append('file', file)
            const response = await api.post<GetExpenseResponse>(
                `/trips/${tripId}/expenses/${expenseId}/picture`,
                formData,
                { headers: { 'Content-Type': 'multipart/form-data' } },
            )
            return response.data
        },
        onSuccess: (_, variables) => {
            queryClient.invalidateQueries({ queryKey: queryKeys.expenses(variables.tripId) })
            queryClient.invalidateQueries({ queryKey: queryKeys.files(variables.tripId) })
        },
    })
}
